"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_STATES = exports.TOKENS = exports.SIZES = exports.TYPES = void 0;
var TYPES = {
  PRIMARY: "primary",
  SECONDARY: "secondary"
};
exports.TYPES = TYPES;
var SIZES = {
  SMALL: "small",
  NORMAL: "normal",
  LARGE: "large"
};
exports.SIZES = SIZES;
var TOKENS = {
  backgroundButton: "backgroundButton",
  backgroundButtonHover: "backgroundButtonHover",
  backgroundButtonActive: "backgroundButtonActive",
  backgroundButtonFocus: "backgroundButtonFocus",
  colorTextButton: "colorTextButton",
  colorTextButtonHover: "colorTextButtonHover",
  colorTextButtonActive: "colorTextButtonActive",
  heightButton: "heightButton",
  fontSizeButton: "fontSizeButton",
  paddingButton: "paddingButton",
  paddingButtonWithIcons: "paddingButtonWithIcons",
  paddingButtonWithLeftIcon: "paddingButtonWithLeftIcon",
  paddingButtonWithRightIcon: "paddingButtonWithRightIcon",
  marginRightIcon: "marginRightIcon"
};
exports.TOKENS = TOKENS;
var BUTTON_STATES = {
  ACTIVE: "active",
  FOCUS: "focus"
};
exports.BUTTON_STATES = BUTTON_STATES;